import React from "react";
import { Image } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import logoImg from "../../../assets/svg/isosustemia 1.svg";
import "./Terminos.scss";

export function Terminos() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <nav className="landing-nav">
        <div className="landing-nav__left" onClick={() => navigate("/admin")} style={{ cursor: "pointer" }}>
          <Image src={logoImg} className="landing-nav__logo-img" />
          <span className="landing-nav__brand">sustemia</span>
        </div>
      </nav>

      <main className="legal-page__content">
        <div className="legal-page__card">
          <h1 className="legal-page__title">Términos y Condiciones</h1>
          <p className="legal-page__subtitle">Sistema de Seguridad e Higiene</p>
          <p className="legal-page__updated">Última actualización: 2026</p>

          <section className="legal-page__section">
            <h2>1. Objeto del servicio</h2>
            <p>
              La plataforma permite gestionar información relacionada con la seguridad e higiene laboral,
              incluyendo incidentes, inspecciones y evaluaciones.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>2. Uso del sistema</h2>
            <p>
              El usuario se compromete a utilizar el sistema de manera legal y conforme a la normativa aplicable.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>3. Cuenta de usuario</h2>
            <p>
              El usuario es responsable de la seguridad de sus credenciales y de la información ingresada.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>4. Datos y contenido</h2>
            <p>
              Toda la información cargada es responsabilidad del cliente. La plataforma actúa como proveedor del servicio.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>5. Responsabilidad</h2>
            <p>No nos responsabilizamos por:</p>
            <ul>
              <li>Datos incorrectos cargados por usuarios</li>
              <li>Uso indebido del sistema</li>
              <li>Decisiones tomadas en base a la información registrada</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>6. Disponibilidad</h2>
            <p>
              El servicio puede ser actualizado, modificado o interrumpido por mantenimiento o mejoras.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>7. Suspensión</h2>
            <p>
              Se podrán suspender cuentas que incumplan estos términos.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>8. Legislación aplicable</h2>
            <p>
              Se aplicarán las leyes correspondientes según la jurisdicción del usuario y normativas internacionales.
            </p>
          </section>

          <div className="legal-page__back">
            <button className="legal-page__back-btn" onClick={() => navigate("/admin")}>
              ← Volver
            </button>
          </div>
        </div>
      </main>

      <footer className="legal-page__footer">
        <span>© 2026 Sustemia</span>
        <span className="legal-page__footer-sep">|</span>
        <span
          className="legal-page__footer-link"
          onClick={() => navigate("/privacidad")}
        >
          Política de Privacidad
        </span>
        <span className="legal-page__footer-sep">|</span>
        <span
          className="legal-page__footer-link"
          onClick={() => navigate("/terminos")}
        >
          Términos y Condiciones
        </span>
      </footer>
    </div>
  );
}
